import { memo, useState } from 'react';
import { Avatar, Box, Button, Group, Menu, Text } from '@mantine/core';
import { IconChartBar, IconLogout } from '@tabler/icons-react';
import { AnalyticsSettingsModal } from '@features/analytics/components/AnalyticsSettingsModal';

interface UserProfileProps {
  user?: {
    name?: string;
    email?: string;
    role?: string;
  } | null;
  onLogout?: () => void;
  showOnMobile?: boolean;
}

export const UserProfile = memo(({user, onLogout, showOnMobile = false}: UserProfileProps) => {
  const [showAnalyticsSettings, setShowAnalyticsSettings] = useState(false);

  if (!user) {
    return;
  }

  return (
    <Box
      hiddenFrom={showOnMobile ? 'md' : undefined}
      visibleFrom={showOnMobile ? undefined : 'md'}
    >
      <Menu
        shadow="md"
        width={200}
        position="bottom-end"
      >
        <Menu.Target>
          <Button
            variant="subtle"
            leftSection={<Avatar size="sm" radius="xl">{(user.name && user.name.length > 0) ? user.name.charAt(0) : (user.email && user.email.length > 0) ? user.email.charAt(0) : 'U'}</Avatar>}
            aria-label={`User menu for ${user.name || user.email || 'User'}`}
            aria-haspopup="menu"
            aria-expanded={false}
            hiddenFrom={showOnMobile ? 'md' : undefined}
            visibleFrom={showOnMobile ? undefined : 'md'}
          >
            <Text visibleFrom={showOnMobile ? undefined : 'md'}>
              {user.name || user.email || 'User'}
            </Text>
          </Button>
        </Menu.Target>

        <Menu.Dropdown>
          <Menu.Label>
            <Group gap="xs">
              <div>
                <Text size="sm" fw={500}>{user.name}</Text>
                <Text size="xs">{user.email}</Text>
                {user.role && (
                  <Text size="xs" tt="capitalize">{user.role}</Text>
                )}
              </div>
            </Group>
          </Menu.Label>

          <Menu.Divider/>

          <Menu.Item
            leftSection={<IconChartBar size={16}/>}
            onClick={() => setShowAnalyticsSettings(true)}
            aria-label="analytics-settings-menu-item"
          >
            Analytics Settings
          </Menu.Item>

          <Menu.Item
            leftSection={<IconLogout size={16}/>}
            onClick={onLogout}
          >
            Sign Out
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>

      <AnalyticsSettingsModal
        opened={showAnalyticsSettings}
        onClose={() => setShowAnalyticsSettings(false)}
      />
    </Box>
  );
});